import React from "react";
import styled from "styled-components";

const FooterWrap = styled.footer`
  width: 100%;
  max-width: 520px;
  margin: 32px auto 0;
  padding: 20px 0 48px;
  border-top: 1px solid #e0d5c8;
`;
const FooterBiz = styled.div`
  font-size: 0.72rem;
  color: #9c7b5a;
  line-height: 2.1;
  margin-bottom: 14px;
  b { color: #7a6654; font-weight: 700; }
`;
const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  a {
    font-size: 0.72rem;
    color: #9c7b5a;
    text-decoration: underline;
    &:hover { color: #3d2b1f; }
  }
`;

export default function SiteFooter() {
  return (
    <FooterWrap>
      <FooterBiz>
        <b>상호명</b>: 우연 &nbsp;|&nbsp; <b>대표자</b>: 김나연 &nbsp;|&nbsp; <b>사업자등록번호</b>: 517-04-03594<br />
        <b>통신판매업신고번호</b>: 신고 진행 중 &nbsp;|&nbsp; <b>연락처</b>: 010-4282-2377<br />
        <b>사업장 주소</b>: 서울시 영등포구 도림로 125가길 14 1층 우연사주<br />
        <b>이메일</b>: wooyeonsaju@gmail.com
      </FooterBiz>
      <FooterLinks>
        <a href="/legal/terms" target="_blank" rel="noreferrer">이용약관</a>
        <a href="/legal/privacy" target="_blank" rel="noreferrer">개인정보 처리방침</a>
        <a href="/legal/refund" target="_blank" rel="noreferrer">환불정책</a>
      </FooterLinks>
    </FooterWrap>
  );
}
